import React from 'react';
import { Row as RowData, RowItem } from '../recs/engine';
import { UserProfile } from '../data/types';
import TitleCard from './TitleCard';
import './Row.css';

// Row ids as defined in recs/engine.ts and useModelRow.ts's MODEL_ROW_ID,
// mapped to the surface names mw_impressions.csv uses for backfill data.
const ROW_ID_TO_SURFACE: Record<string, string> = {
  'continue-watching': 'home_row_continue_watching',
  'live-now': 'home_row_live_now',
  trending: 'home_row_trending',
  new: 'home_row_new_on_watch',
  'recommended-for-you': 'home_row_recommended_for_you',
};

interface Props {
  row: RowData;
  viewer: UserProfile;
  onSelectItem: (item: RowItem) => void;
}

export default function Row({ row, viewer, onSelectItem }: Props) {
  const surface = ROW_ID_TO_SURFACE[row.id] ?? row.id;
  return (
    <section className="row">
      <h2 className="row__title">{row.title}</h2>
      <div className="row__track">
        {row.items.map((item, index) => (
          <TitleCard
            key={`${row.id}-${item.title.title_id}`}
            item={item}
            viewer={viewer}
            onSelect={onSelectItem}
            surface={surface}
            rowPosition={index + 1}
          />
        ))}
      </div>
    </section>
  );
}
